var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainSideBarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFBE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSideBarIcon);
export default __webpack_public_path__ + "static/media/mainSideBarIcon.eeb53ccc8dfda7168b519e31a6851d57.svg";
export { ForwardRef as ReactComponent };